export enum Vote {
  SUPPORT = 0,
  FOR = 1,
  ABSTAIN = 2,
}
